import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useGetCategoryQuery } from "../../../features/api/categoryApi";
import { useGetProductQuery } from "../../../features/api/productApi";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";
import { useAddNewModelMutation } from "../../../features/api/modelApi";

const AddSubItemList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [cat_name, setCategory] = useState(0);
  const [sub_catName, setSubCategory] = useState(0);

  const { data } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const filterSubCat = subCategory?.filter(
    (item) => item?.cat_name == cat_name
  );
  const filterProduct = products?.filter(
    (item) => item?.sub_catName == sub_catName
  );

  const [product_name, setProduct] = useState(0);
  const [model, setModel] = useState("");

  const [addNewModel] = useAddNewModelMutation();
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const newProductModel = {
        model_name: model,
        category_id: +cat_name,
        subcategory_id: +sub_catName,
        product_id: +product_name,
      };
      const response = await addNewModel(newProductModel);
      if (response?.data) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Model created successfully...!!!");
      } else if (response?.errors) {
        setIsOpen(false);
        toast.error("Model created error");
      }
    } catch (error) {
      console.error("Error creating data:", error);
    }
  };

  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white rounded-sm bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Sub Item List
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <h1 className="font-medium">Create Model</h1>
              <div className="card-body">
                <form
                  onSubmit={handleAdd}
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <select
                      onChange={(e) => setCategory(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--Select Category--</option>
                      {categories?.map((category) => (
                        <option key={category?.id} value={category?.id}>
                          {category?.cat_name}
                        </option>
                      ))}
                    </select>

                    <select
                      onChange={(e) => setSubCategory(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {filterSubCat?.map((category) => (
                        <option key={category?.id} value={category?.id}>
                          {category?.sub_catName}
                        </option>
                      ))}
                    </select>

                    <select
                      onChange={(e) => setProduct(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {filterProduct?.map((product) => (
                        <option key={product?.id} value={product?.id}>
                          {product?.product_name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      onChange={(e) => setModel(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Enter Model Name..."
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSubItemList;
